// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vksk","left":"styles_left__1GTJQ"};